import LoadDashboard from "./LoadDashboard";

export default LoadDashboard;